module.exports = __webpack_public_path__ + "img/组 151@2x.edb2aa02.png";